<template>
  <div
    class="form-actions"
    ref="formActions"
  >
    <div>
      <Button
        v-if="actionButtonsProps('preview').visible"
        @click="handleOpenPreview()"
        class="button-preview"
        data-test="preview_invoice"
        icon="icon icon-eye"
        new-design
        no-border
        ph-autocapture
        plain
        size="large"
        type="primary"
      >
        {{ $t('form.invoiceForm.buttons.preview') }}
      </Button>
    </div>
    <div>
      <Checkbox
        v-if="actionButtonsProps('eetEvidence').visible"
        v-model="register_eet"
        class="eet-checker"
        :disabled="actionButtonsProps('eetEvidence').disabled"
        data-test="eet-registered"
      >
        <strong>{{ $t('form.invoiceForm.fields.eetSettings.eetEvidence') }}</strong>
      </Checkbox>

      <Button
        :loading="buttonLoading.save"
        @click="submit('save')"
        class="submit-button"
        data-test="save_invoice"
        icon="icon icon-save-alt"
        new-design
        no-border
        plain
        size="large"
        type="primary"
        v-if="actionButtonsProps('save').visible"
      >
        {{ $t(`form.invoiceForm.buttons.save${buttonPostfix}`) }}
      </Button>
      <Button
        class="submit-button button-mobile"
        @click="showSubmitDialog()"
        v-if="actionButtonsProps('submit').visible"
        icon="icon icon-send-line"
        data-test="show_submit_dialog"
        new-design
        plain
        size="large"
        type="primary"
      >
        {{ $t(`form.invoiceForm.buttons.sendByEmail${buttonPostfix}`) }}
      </Button>
      <Button
        @click="handleDownload()"
        v-if="actionButtonsProps('download').visible"
        class="submit-button button-mobile"
        data-test="download_invoice"
        icon="icon icon-download-new"
        new-design
        size="large"
        type="warning"
      >
        {{ $t('form.invoiceForm.buttons.downloadOnly') }}
      </Button>
      <Button
        @click="elInvoiceForm.correctionInvoiceRedirect"
        v-if="actionButtonsProps('correctionInvoice').visible"
        class="submit-button button-mobile"
        data-test="correction_invoice"
        icon="icon icon-pen"
        new-design
        plain
        size="large"
        type="warning"
      >
        {{ $t('form.invoiceForm.buttons.correction_invoice') }}
      </Button>
      <Button
        :loading="buttonLoading.saveAndDownload"
        @click="submit('saveAndDownload')"
        class="submit-button button-mobile"
        data-test="save_download_invoice"
        icon="icon icon-download-new"
        new-design
        size="large"
        type="warning"
        v-if="actionButtonsProps('saveAndDownload').visible"
      >
        {{ $t(`form.invoiceForm.buttons.download${buttonPostfix}`) }}
      </Button>
    </div>
  </div>
</template>

<script>

import ActionButtons from '../../../InvoiceForm/sections/ActionButtons.vue';

export default {
  extends: ActionButtons,
};
</script>

<style lang="scss" scoped>
.form-actions {
  background: $--color-white;
  border-radius: 12px;
  border: 1px solid $--border-secondary;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 15px 25px;
  transform: translateY(0);
  transition: transform .3s ease-in-out;
  z-index: $--index-top;

  @media only screen and (min-width: $--breakpoint-sm) {
    position: sticky;
    bottom: 0;
  }

  @media only screen and (width <= 800px) {
    display: block;
  }

  @media only screen and (max-width: $--breakpoint-sm - 1px) {
    margin-left: math.div($grid-gutter-width, -2);
    margin-right: math.div($grid-gutter-width, -2);
    padding-left: math.div($grid-gutter-width, 2);
    padding-right: math.div($grid-gutter-width, 2);

    .el-button {
      width: 100%;
      display: flex;
      margin-bottom: 1rem;
    }
  }

  &.affixed {
    @media only screen and (min-width: $--breakpoint-sm) {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      transition: .3s ease;
      box-shadow: 0 -6px 12px 0 rgba(17, 24, 39, 10%);
    }
  }

  &.not-visible {
    @media only screen and (min-width: $--breakpoint-sm) {
      transform: translateY(100%);

      &::before {
        opacity: 0;
      }
    }
  }
}

.button-preview {
  @media only screen and (width <= 800px) {
    margin-bottom: 12px;
  }

  @media only screen and (width <= 600px) {
    width: 100%;
    margin-bottom: 0;
  }
}

.eet-checker {
  display: inline-block;
  margin: auto 10px;

  @media only screen and (width <= 800px) {
    margin: 12px 0 22px;
    display: block;
  }

  @media only screen and (width <= 600px) {
    display: inline-block;
  }
}

.submit-button {
  @media only screen and (width <= 600px) {
    margin: 10px 0 1rem !important;
    width: 100%;
  }
}
</style>
